import { IShopCard, IShopCardData, IShopCardAction } from 'models/shop/shopcard';
import { IFollowCardItem } from 'models/verticalwidgetcards/followcard';
import { IFollowingItem, IPage, IFollowerDto, ISearchDto, IEntityDto } from 'models/common';
import { IStore } from 'redux/IStore';
import { IUserPreferences } from 'models/user/userpreferences';
import * as c from 'models/constants';
import { browserHistory } from 'react-router';
import {
	resetSearchData as resetProductData,
	setProductSelectedCategory,
	getProductSearchResults,
	setProductSortOrder,
	setProductSearchResultsFilters,
} from 'redux/modules/search/productsearchresults';
import { SearchUsage } from 'models/enums/searchusage';
import { IRefinementGroup, IRefinement } from 'models/filtering/refinement';
import { IProductBaseSearchResultsData } from 'models/search/productbasesearchresults';
import { ProductRefinementGroupings, ShopStatus } from 'models';
import { IShopShippingOption } from 'models/shop/shopshippingoption';
import { getShopReviews } from '../shopreviews';
import * as i18n from 'i18next';
import { actions as notifActions } from 'redux-notifications';
import { getCustomers, getOfficeMembers, getShopAdmins, getShopOffices } from '../helpers';
import { ICustomer } from 'models/shop/customer';
import { accessTokenIsPresent } from 'containers/AccessControl/helpers';
import { IOffice } from 'models/shop/office';
import { requestHelper } from 'redux/helpers';
import { ICustomerApiResponse } from 'models/shop/customer';
const { notifSend } = notifActions;

/** Action Types */
export const GET_REQUEST: string = 'shopcard/GET_REQUEST';
export const GET_SUCCESS: string = 'shopcard/GET_SUCCESS';
export const GET_FAILURE: string = 'shopcard/GET_FAILURE';
export const CHANGE_SELECTED_TAB: string = 'shopcard/CHANGE_SELECTED_TAB';
export const FOLLOW_SHOP_REQUEST: string = 'shopcard/FOLLOW_SHOP_REQUEST';
export const FOLLOW_SHOP_SUCCESS: string = 'shopcard/FOLLOW_SHOP_SUCCESS';
export const FOLLOW_SHOP_FAILURE: string = 'shopcard/FOLLOW_SHOP_FAILURE';
export const GET_CUSTOMERS_REQUEST: string = 'shopcard/GET_CUSTOMERS_REQUEST';
export const RESET_CUSTOMERS_REQUEST: string = 'shopcard/RESET_CUSTOMERS_REQUEST';
export const GET_CUSTOMERS_CUSTOMER_REQUEST: string = 'shopcard/GET_CUSTOMERS_CUSTOMER_REQUEST';
export const RESET_CUSTOMERS_CUSTOMER_REQUEST: string = 'shopcard/RESET_CUSTOMERS_CUSTOMER_REQUEST';
export const SET_CUSTOMER_REQUEST: string = 'shopcard/SET_CUSTOMER_REQUEST';
export const SET_IS_FOLLOWED: string = 'shopcard/SET_IS_FOLLOWED';
export const GET_SHOP_FOLLOWERS_SUCCESS: string = 'shopcard/GET_SHOP_FOLLOWERS_SUCCESS';
export const SET_SHOP_FOLLOWERS_PAGE: string = 'shopcard/SET_SHOP_FOLLOWERS_PAGE';
export const SET_IS_MY_SHOP: string = 'shopcard/SET_IS_MY_SHOP';
export const RESET_SHOP_FOLLOWERS_DATA: string = 'shopcard/RESET_SHOP_FOLLOWERS_DATA';
export const RESET_DATA: string = 'shopcard/RESET_DATA';
export const UNFOLLOW_SHOP_SUCCESS: string = 'shopcard/UNFOLLOW_SHOP_SUCCESS';
export const SET_KEYWORD_FILTER: string = 'products/SET_KEYWORD_FILTER';
export const SET_NAVIGATE_TO_SHOP_FOLLOWERS: string = 'shopcard/SET_NAVIGATE_TO_SHOP_FOLLOWERS';
export const GET_SHIPPING_OPTIONS_SUCCESS: string = 'shopcard/GET_SHIPPING_OPTIONS_SUCCESS';
export const GET_COMMENTS_SUCCESS: string = 'shopcard/GET_COMMENTS_SUCCESS';
export const RESET_COMMENTS_DATA: string = 'shopcard/RESET_COMMENTS_DATA';
export const SET_COMMENTS_PAGE: string = 'shopcard/SET_COMMENTS_PAGE';
export const SET_IS_COMMENTS_FIRST_LOAD: string = 'shopcard/SET_IS_COMMENTS_FIRST_LOAD';
export const SET_EDIT_SERVICES_POSITION: string = 'shopcard/SET_EDIT_SERVICES_POSITION';

/** Initial State */
const initialState: IShopCardData = {
	isFetching: false,
	shopcard: null,
	isFollowed: null,
	followersItems: [],
	followersPage: {
		currentPage: 0,
		itemsPerPage: 10,
	},
	//showFollowers: false,
	isMyShop: false,
	selectedTab: c.SHOPCARD_TAB_OVERVIEW,
	keywordFilter: '',
	shippingOptions: [],
	customers: {
		currentPage: 0,
		totalItems: 0,
		totalPages: 0,
		itemsPerPage: c.SHOPCARD_TAB_CUSTOMERS_ITEMSPERPAGE,
		items: [],
	},
	selectedCustomer: {},
};

/** Reducer */
export function shopCardReducer(state = initialState, action: IShopCardAction): IShopCardData {
	switch (action.type) {
		case GET_REQUEST:
			return {
				...state,
				isFetching: true,
			};

		case GET_SUCCESS: {
			const payloadCard = action.payload.shopcard;
			if (!payloadCard) {
				return { ...state, isFetching: false };
			}
			// Merge old and new info
			let resultCard = { ...state.shopcard };
			if (resultCard.id !== payloadCard.id) {
				resultCard = payloadCard;
			} else {
				let offices: IOffice[];
				if (payloadCard.offices) {
					offices = payloadCard.offices;
				}
				const oldOffices = state.shopcard?.offices;
				if (oldOffices) {
					if (!offices) {
						offices = oldOffices;
					} else {
						offices = offices.map((off) => {
							const old = oldOffices.find((o) => o.id === off.id);
							if (!old) {
								return off;
							}
							const staff = off.staff ? off.staff : old.staff;
							return {
								...off,
								staff,
							};
						});
					}
				}
				resultCard = {
					...payloadCard,
					offices,
				};
			}
			return {
				...state,
				shopcard: resultCard,
				isFetching: false,
				error: false,
			};
		}

		case GET_CUSTOMERS_REQUEST:
			return {
				...state,
				customers: action.payload.customers,
				isFetching: false,
			};

		case RESET_CUSTOMERS_REQUEST:
			return {
				...state,
				customers: {
					currentPage: 0,
					totalItems: 0,
					totalPages: 0,
					itemsPerPage: 20,
					items: [],
				},
			};

		case GET_CUSTOMERS_CUSTOMER_REQUEST:
			return {
				...state,
				selectedCustomer: action.payload.selectedCustomer,
				isFetching: false,
			};

		case RESET_CUSTOMERS_CUSTOMER_REQUEST:
			return {
				...state,
				selectedCustomer: {},
			};

		case SET_CUSTOMER_REQUEST:
			return {
				...state,
				customers: action.payload.customers,
			};

		case GET_FAILURE:
			return {
				...state,
				message: action.payload.message,
				error: true,
			};

		case CHANGE_SELECTED_TAB:
			return {
				...state,
				selectedTab: action.payload.selectedTab,
				tabNamespace: action.payload.tabNamespace,
			};

		case FOLLOW_SHOP_SUCCESS:
			return {
				...state,
				isFollowed: true,
			};

		case FOLLOW_SHOP_REQUEST:
			return {
				...state,
				isFollowed: undefined,
			};

		case FOLLOW_SHOP_FAILURE:
			return {
				...state,
				message: action.payload.message,
				error: true,
			};

		case SET_IS_FOLLOWED:
			return {
				...state,
				isFollowed: action.payload.isFollowed,
			};

		case GET_SHOP_FOLLOWERS_SUCCESS:
			return {
				...state,
				followersItems: action.payload.followersItems,
				isFetching: false,
			};

		case SET_SHOP_FOLLOWERS_PAGE:
			return {
				...state,
				followersPage: action.payload.followersPage,
			};

		case SET_IS_MY_SHOP:
			return {
				...state,
				isMyShop: action.payload.isMyShop,
			};

		case RESET_SHOP_FOLLOWERS_DATA:
			return {
				...state,
				followersItems: [],
				followersPage: {
					currentPage: 0,
					itemsPerPage: 10,
				},
			};

		case RESET_DATA: {
			return Object.assign({}, initialState, state);
		}
		case UNFOLLOW_SHOP_SUCCESS:
			return {
				...state,
				isFollowed: false,
			};

		case SET_KEYWORD_FILTER:
			return {
				...state,
				keywordFilter: action.payload.keywordFilter,
			};

		case SET_NAVIGATE_TO_SHOP_FOLLOWERS:
			return {
				...state,
				navigateToFollowers: action.payload.navigateToFollowers,
			};

		case GET_SHIPPING_OPTIONS_SUCCESS:
			return {
				...state,
				shippingOptions: action.payload.shippingOptions,
			};

		case SET_EDIT_SERVICES_POSITION:
			return {
				...state,
				editServicesPagePosition: action.payload.editServicesPagePosition,
			};

		default:
			return state;
	}
}

/** Action Creator */
export function changeTabAndGetRequiredData(
	selectedTab: string,
	tabNamespace: string,
	shopId: string,
	categoryId: number,
	order: number,
	r1: number,
	r2: number,
	r3: boolean,
	r4: string,
	r5: string,
	navigateToFollowers?: boolean,
) {
	return (dispatch, getState: () => IStore) => {
		dispatch(changeSelectedTab(selectedTab, tabNamespace));

		switch (selectedTab) {
			case c.SHOPCARD_TAB_OVERVIEW:
			case c.SHOPCARD_TAB_PRODUCTS:
				//if any parameter is changed - reset search data and repopulate reducer
				//check refinements complex object
				let r: string = null;
				let currentPricesRefinementGroup: string = null;
				let prevPricesRefinementGroup: string = null;
				let refinementSelections: string = null;
				let refinementUrl: IProductBaseSearchResultsData = null;
				if (
					getState().productSearchResults.refinementSelections &&
					getState().productSearchResults.refinementSelections.length
				) {
					const temp: IRefinementGroup[] = [];
					getState().productSearchResults.refinementSelections.forEach((reducerRefinementGroup: IRefinementGroup) => {
						const refinementGroup: IRefinementGroup = {};
						refinementGroup.groupId = reducerRefinementGroup.groupId;
						refinementGroup.refinements = [];
						reducerRefinementGroup.refinements.forEach((reducerRefinement: IRefinement) => {
							const irefinement: IRefinement = { id: reducerRefinement.id };
							refinementGroup.refinements.push(irefinement);
						});
						if (refinementGroup && refinementGroup.refinements.length) {
							temp.push(refinementGroup);
						}
					});
					r = new URLSearchParams(JSON.stringify(temp)).toString();
				}
				//we need only price group because it is a hack and stored in refinement group and not in selections
				if (
					getState().productSearchResults.refinementGroups &&
					getState().productSearchResults.refinementGroups.length
				) {
					const temp: IRefinementGroup[] = [];
					getState()
						.productSearchResults.refinementGroups.filter((x) => x.groupId === ProductRefinementGroupings.Price)
						.forEach((reducerRefinementGroup: IRefinementGroup) => {
							const refinementGroup: IRefinementGroup = {};
							refinementGroup.groupId = reducerRefinementGroup.groupId;
							refinementGroup.refinements = [];
							reducerRefinementGroup.refinements.forEach((reducerRefinement: IRefinement) => {
								const irefinement: IRefinement = { id: reducerRefinement.id };
								refinementGroup.refinements.push(irefinement);
							});
							if (refinementGroup && refinementGroup.refinements.length) {
								temp.push(refinementGroup);
							}
						});
					currentPricesRefinementGroup = new URLSearchParams(JSON.stringify(temp)).toString();
				}
				if (r1 && r2) {
					refinementUrl = {};
					refinementUrl.lastSelectedRefinementItemId = r1;
					refinementUrl.lastSelectedRefinementGroupId = r2;
					refinementUrl.lastActionWasToNarrowRefinement = r3;
					refinementUrl.refinementGroups = [];
					refinementUrl.refinementSelections = [];
					if (r4 && r4.length) {
						r4.split('g').forEach((group: string) => {
							if (group && group.length) {
								const refinementGroup: IRefinementGroup = {};
								const groupId: number = parseInt(group.substr(0, 1), 10);
								refinementGroup.groupId = groupId;
								refinementGroup.refinements = [];
								group
									.substr(1)
									.split('r')
									.forEach((refinement: string) => {
										if (refinement && refinement.length) {
											const refinementId: number = parseInt(refinement.substr(0), 10);
											const irefinement: IRefinement = { id: refinementId };
											refinementGroup.refinements.push(irefinement);
										}
									});
								if (refinementGroup && refinementGroup.refinements.length) {
									refinementUrl.refinementSelections.push(refinementGroup);
								}
							}
						});
					}
					if (r5 && r5.length) {
						r5.split('g').forEach((group: string) => {
							if (group && group.length) {
								const refinementGroup: IRefinementGroup = {};
								const groupId: number = parseInt(group.substr(0, 1), 10);
								refinementGroup.groupId = groupId;
								refinementGroup.refinements = [];
								group
									.substr(1)
									.split('r')
									.forEach((refinement: string) => {
										if (refinement && refinement.length) {
											const refinementId: number = parseInt(refinement.substr(0), 10);
											const irefinement: IRefinement = { id: refinementId };
											refinementGroup.refinements.push(irefinement);
										}
									});
								if (refinementGroup && refinementGroup.refinements.length) {
									refinementUrl.refinementGroups.push(refinementGroup);
								}
							}
						});
						prevPricesRefinementGroup = new URLSearchParams(
							JSON.stringify(
								refinementUrl.refinementGroups.filter((x) => x.groupId === ProductRefinementGroupings.Price),
							),
						).toString();
					}
					refinementSelections = new URLSearchParams(JSON.stringify(refinementUrl.refinementSelections)).toString();
				} else if (r5 && r5.length) {
					refinementUrl = {};
					refinementUrl.lastSelectedRefinementItemId = null;
					refinementUrl.lastSelectedRefinementGroupId = null;
					refinementUrl.lastActionWasToNarrowRefinement = false;
					refinementUrl.refinementGroups = [];
					refinementUrl.refinementSelections = [];
					r5.split('g').forEach((group: string) => {
						if (group && group.length) {
							const refinementGroup: IRefinementGroup = {};
							const groupId: number = parseInt(group.substr(0, 1), 10);
							refinementGroup.groupId = groupId;
							refinementGroup.refinements = [];
							group
								.substr(1)
								.split('r')
								.forEach((refinement: string) => {
									if (refinement && refinement.length) {
										const refinementId: number = parseInt(refinement.substr(0), 10);
										const irefinement: IRefinement = { id: refinementId };
										refinementGroup.refinements.push(irefinement);
									}
								});
							if (refinementGroup && refinementGroup.refinements.length) {
								refinementUrl.refinementGroups.push(refinementGroup);
							}
						}
					});
					prevPricesRefinementGroup = new URLSearchParams(
						JSON.stringify(
							refinementUrl.refinementGroups.filter((x) => x.groupId === ProductRefinementGroupings.Price),
						),
					).toString();
				}

				if (
					categoryId !== getState().productSearchResults.selectedCategoryId ||
					order !== getState().productSearchResults.sortOrder ||
					refinementSelections !== r ||
					(prevPricesRefinementGroup !== currentPricesRefinementGroup && prevPricesRefinementGroup !== null) //hack because always returns price refinment
				) {
					dispatch(resetProductData());
					dispatch(setProductSelectedCategory(categoryId));
					dispatch(setProductSortOrder(order));

					if (refinementUrl) {
						dispatch(setProductSearchResultsFilters(refinementUrl));
					}
					dispatch(getProductSearchResults(true, true, SearchUsage.ProductsShopCard));
				}
				break;

			case c.USERCARD_TAB_FOLLOWERS:
				const shopCardState: IShopCardData = getState().shopcard;
				if (navigateToFollowers !== undefined && navigateToFollowers !== shopCardState.navigateToFollowers) {
					dispatch(setNavigateToShopFollowers(navigateToFollowers));
				}
				// dispatch(getShopFollowers(shopId, true, null));
				break;

			case c.SHOPCARD_TAB_ABOUT:
				dispatch(getShopReviews(shopId, true));
				break;

			case c.SHOPCARD_TAB_POLICIES:
				dispatch(getShopShippingOptions(shopId));
				break;

			case c.SHOPCARD_TAB_REVIEWS:
				dispatch(getShopReviews(shopId, true));
				break;

			default:
				break;
		}
	};
}

/** Action Creator */
export function changeSelectedTab(selectedTab: string, tabNamespace: string): IShopCardAction {
	return {
		type: CHANGE_SELECTED_TAB,
		payload: {
			selectedTab,
			tabNamespace,
		},
	};
}

/** Action Creator */
export function getShopCardByCode(
	code: string,
	getOffices?: boolean,
	getStaffForOffices?: boolean,
	getAdmins?: boolean,
) {
	return (dispatch, getState: () => IStore): Promise<any> => {
		dispatch(shopCardRequest());

		const userPreferences: IUserPreferences = getState().userPreferences;

		return (
			requestHelper<IShopCard>(
				fetch(
					getState().fetchDefault.baseAPI + 'api/Shop/' + code + '/GetByCode',
					Object.assign({}, getState().fetchDefault.requestInit),
				),
			)
				// GET shop offices with staff members
				.then((shop: IShopCard) => {
					let promise: Promise<IShopCard> = Promise.resolve(shop);
					if (getOffices) {
						promise = promise.then(() =>
							getShopOffices(getState, shop.id, getStaffForOffices)
								.then((offices) => ({ ...shop, offices }))
								.catch((res) => {
									const status: number = res.status;
									const statusText: string = res.statusText;
									const message: any = { status, statusText };
									dispatch(shopCardFailure(message));
									return shop;
								}),
						);
					}

					if (getAdmins) {
						promise = promise.then((enrichedShop) =>
							getShopAdmins(getState, enrichedShop.id, oldAbortController, false)
								.then((admins) => ({
									...enrichedShop,
									admins,
								}))
								.catch(() => {
									// console.error(res);
									return enrichedShop;
								}),
						);
					}
					return promise.then((s) => setShopCardData(s, userPreferences, dispatch));
				})
				.catch((res) => dispatch(shopCardFailure(res)))
		);
	};
}

export function getOfficeStaff(officeId: string, overwriteIfExists = false, entireShopcard?: IShopCardData) {
	return (dispatch, getState: () => IStore) => {
		const shopCard = entireShopcard ? entireShopcard.shopcard : getState().shopcard.shopcard;
		const existing = shopCard?.offices?.find((o) => o.id === officeId)?.staff;
		if (existing && !overwriteIfExists) {
			return;
		}
		return getOfficeMembers(getState, shopCard?.id, officeId)
			.then((staff) => {
				const shop = { ...(shopCard || {}) } as IShopCard;
				const offices = [...(shop.offices || [])];
				const officeIndex = offices.findIndex((o) => o.id === officeId);
				if (officeIndex >= 0) {
					offices[officeIndex].staff = staff;
				} else {
					offices.push({
						id: officeId,
						staff,
					} as IOffice);
				}
				shop.offices = offices;
				dispatch(shopCardSuccess(shop));
			})
			.catch((res: Response) => {
				dispatch(shopCardFailure(res));
			});
	};
}

/** Action Creator */
export function getShopCard(
	id: string,
	target?: string | false,
	getOffices?: boolean,
	getStaffForOffices?: boolean,
	officeId?: string,
) {
	return (dispatch, getState: () => IStore) => {
		dispatch(shopCardRequest());

		const userPreferences: IUserPreferences = getState().userPreferences;

		return (
			requestHelper<IShopCard>(
				fetch(
					getState().fetchDefault.baseAPI + 'api/shop/' + id,
					Object.assign({}, getState().fetchDefault.requestInit),
				),
			)
				.then((x: IShopCard) => {
					if (!getOffices) {
						setShopCardData(x, userPreferences, dispatch);
					}
					if (target !== false) {
						const url = '/shop/' + x.code;
						if (target && target.length > 0) {
							window.open(url, target);
						} else {
							browserHistory.push(url);
						}
					}
					return x;
				})
				// GET shop offices with staff members
				.then((shop: IShopCard) => {
					if (getOffices) {
						getShopOffices(getState, shop.id, getStaffForOffices)
							.then((offices) => {
								const newShopCard = { ...getState().shopcard, shopcard: { ...shop, offices } };
								// If fetching staff for single office
								if (officeId && !getStaffForOffices) {
									dispatch(getOfficeStaff(officeId, true, newShopCard));
								} else {
									dispatch(shopCardSuccess({ ...shop, offices }));
								}
							})
							.catch((res) => {
								const status: number = res.status;
								const statusText: string = res.statusText;
								const message: any = { status, statusText };
								dispatch(shopCardFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(shopCardFailure(err));
				})
		);
	};
}

function setShopCardData(res: IShopCard, userPreferences: IUserPreferences, dispatch) {
	dispatch(shopCardSuccess(res));

	if (userPreferences && userPreferences.id) {
		if (res.ownerId === userPreferences.id || res?.admins?.some((admin) => userPreferences.id == admin.id)) {
			dispatch(setIsMyShop(true));
		} else {
			dispatch(setIsMyShop(false));
		}
		dispatch(getShopCardFollowButtonData());
	} else {
		dispatch(setShopIsFollowed(false));
	}
}

/** Action Creator */
export function getShopCardFollowButtonData() {
	return (dispatch, getState: () => IStore) => {
		if (!accessTokenIsPresent()) {
			return Promise.resolve(false);
		}
		// dispatch(shopCardRequest());

		const entityId = getState().shopcard?.shopcard?.entityId;
		if (!entityId) {
			return Promise.resolve(false);
		}
		return fetch(
			getState().fetchDefault.baseAPI + 'api/User/Following',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify([{ entityId }]),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => dispatch(setShopIsFollowed(res[0].value)));
				} else {
					return res.json().then((res) => dispatch(shopCardFailure(res)));
				}
			})
			.catch((err) => {
				dispatch(shopCardFailure(err));
			});
	};
}

/** Action Creator */
export function setShopStatus(id: string, status: ShopStatus) {
	return (dispatch, getState: () => IStore) => {
		dispatch(shopCardRequest());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Shop/' + id + '/SetStatus/' + status,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'PUT',
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(updateShopStatus(status));
					dispatch(
						notifSend({ message: i18n.t('Notification_Success_Shop_Approved'), kind: 'success', dismissAfter: 3000 }),
					);
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(shopCardFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(shopCardFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(shopCardFailure(err));
			});
	};
}

/** Action Creator */
export function updateShopStatus(status: ShopStatus) {
	return (dispatch, getState: () => IStore) => {
		const shopCardState = getState().shopcard;
		const item = shopCardState.shopcard;
		item.status = status;
		dispatch(shopCardSuccess(item));
	};
}

/** Action Creator */
export function addShopCustomer(
	shopId: string,
	name: string,
	callingCodeKey: number,
	phoneNumber: string,
	email: string,
	lastOrderDate: string,
	languageKey: number,
) {
	return (dispatch, getState: () => IStore): Promise<{ error: boolean; customer?: ICustomer }> => {
		const body: ICustomer = {
			shopId,
			name,
			callingCodeKey: phoneNumber ? callingCodeKey : null,
			phoneNumber,
			lastOrderDate,
			email: email || '',
			languageKey,
		};

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Shop/Customers',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(body),
			}),
		).then((res) => {
			if (res.ok) {
				return res.json().then((customer: ICustomer) => {
					const state = getState().shopcard;

					return dispatch(getShopCustomers(state.shopcard?.id, state.customers?.currentPage || 1, true))?.then(() => {
						return { error: false, customer };
					});
				});
			} else {
				return res.json().then((res) => {
					dispatch(shopCardFailure(res));
					return { error: true };
				});
			}
		});
	};
}

export function addShopCustomerObj(customer: ICustomer) {
	return (dispatch, getState: () => IStore): Promise<{ error: boolean; customer?: ICustomer }> => {
		const body: ICustomer = {
			...customer,
			callingCodeKey: customer.phoneNumber ? customer.callingCodeKey : null,
			email: customer.email || '',
		};

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Shop/Customers',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(body),
			}),
		).then((res) => {
			if (res.ok) {
				return res.json().then((customer: ICustomer) => {
					const state = getState().shopcard;

					return dispatch(getShopCustomers(state.shopcard?.id, state.customers?.currentPage || 1, true))?.then(() => {
						return { error: false, customer };
					});
				});
			} else {
				return res.json().then((res) => {
					dispatch(shopCardFailure(res));
					return { error: true };
				});
			}
		});
	};
}

/** Action Creator */
export function getShopCustomers(shopId: string, currentPage?: number, clean?: boolean, keyword?: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(shopCardRequest());

		const shopCardData: IShopCardData = getState().shopcard;
		const userPreferences: IUserPreferences = getState().userPreferences;

		return fetch(
			getState().fetchDefault.baseAPI + 'api/shop/' + shopId,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res
						.json()
						.then((x: IShopCard) => {
							setShopCardData(x, userPreferences, dispatch);
							return x;
						})
						.then((shop: IShopCard) => {
							getCustomers(getState, shop.id, currentPage, keyword)
								.then((customers: IPage<ICustomer>) => {
									const existingCustomerItems = shopCardData.customers?.items;
									const customersToSet: IPage<ICustomer> = {
										...customers,
										items: clean ? [...customers.items] : [...existingCustomerItems, ...customers.items],
									};
									// Filter out walk-in customer
									if (customers?.items?.find((i) => i?.email === 'walk-in@glossiq.com')) {
										customersToSet.totalItems = customers.totalItems - 1;
									}
									const filteredCustomerItems = [...customersToSet.items].filter(
										(customer) => customer?.email !== 'walk-in@glossiq.com',
									);
									customersToSet.items = filteredCustomerItems;

									dispatch(setShopCustomersRequest(customersToSet));
								})
								.catch((err) => {
									dispatch(shopCardFailure(err));
								});
						})
						.catch((err) => {
							dispatch(shopCardFailure(err));
						});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(shopCardFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(shopCardFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(shopCardFailure(err));
			});
	};
}

/** Action Creator */
export function getOneShopCustomer(customerId: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(shopCardRequest());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Shop/Customers/' + customerId,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res
						.json()
						.then((x: ICustomerApiResponse) => {
							const modifiedResponse: ICustomer = {
								...x,
								hairProducts: (x.hairProducts || '').split(',').filter(Boolean).map(Number),
								brands: (x.brands || '').split(',').filter(Boolean).map(Number),
								goals: (x.goals || '').split(',').filter(Boolean).map(Number),
								skinProblems: (x.skinProblems || '').split(',').filter(Boolean).map(Number),
							};
							if (modifiedResponse?.email === 'walk-in@glossiq.com') {
								modifiedResponse.name = i18n.t('Customer_Walk-in');
								// modifiedResponse.email = undefined;
							}
							dispatch(setShopSingleCustomerRequest(modifiedResponse));
						})
						.catch((err) => {
							dispatch(shopCardFailure(err));
						});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(shopCardFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(shopCardFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(shopCardFailure(err));
			});
	};
}

/** Action Creator */
export function updateShopCustomer(newData: Partial<ICustomer>, displaySuccessNotification: boolean = true) {
	return (dispatch, getState: () => IStore) => {
		dispatch(shopCardRequest());
		const selectedCustomer = getState().shopcard?.selectedCustomer;

		const customerData = () => {
			const modifiedNewData = Object.assign({}, newData);

			delete modifiedNewData.hairProducts;
			delete modifiedNewData.brands;
			delete modifiedNewData.goals;
			delete modifiedNewData.skinProblems;

			const data: ICustomerApiResponse = {
				...selectedCustomer,
				...modifiedNewData,
			};
			data.callingCodeKey = newData?.phoneNumber ? newData?.callingCodeKey : null;
			data.hairProducts = newData?.hairProducts?.join(',') || '';
			data.brands = newData?.brands?.join(',') || '';
			data.goals = newData?.goals?.join(',') || '';
			data.skinProblems = newData?.skinProblems?.join(',') || '';
			if (data.coloredHair) {
				if ((data.coloredHair as any) === '0') {
					data.coloredHair = false as any;
				} else if ((data.coloredHair as any) === '1') {
					data.coloredHair = true as any;
				}
			}
			return data;
		};

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Shop/Customers/' + selectedCustomer.id,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'PUT',
				body: JSON.stringify(customerData()),
			}),
		)
			.then((res) => {
				if (res.ok) {
					if (selectedCustomer) {
						if (displaySuccessNotification) {
							dispatch(
								notifSend({
									message: i18n.t('CustomerBusinessRules_ValidationSuccess') + ` ${selectedCustomer.name}`,
									kind: 'success',
									dismissAfter: 3000,
								}),
							);
						}
						return dispatch(getOneShopCustomer(selectedCustomer.id))?.then(() => ({ error: false }));
					}
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(shopCardFailure(res));
							dispatch(
								notifSend({
									message: i18n.t('CustomerBusinessRules_ValidationFailed') + ` ${selectedCustomer.name}`,
									kind: 'error',
									dismissAfter: 3000,
								}),
							);
							return { error: true };
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(shopCardFailure(message));
							dispatch(
								notifSend({
									message: i18n.t('CustomerBusinessRules_ValidationFailed') + ` ${selectedCustomer.name}`,
									kind: 'error',
									dismissAfter: 3000,
								}),
							);
							return { error: true };
						});
				}
			})
			.catch((err) => {
				dispatch(shopCardFailure(err));
				dispatch(
					notifSend({
						message: i18n.t('CustomerBusinessRules_ValidationFailed') + ` ${selectedCustomer.name}`,
						kind: 'error',
						dismissAfter: 3000,
					}),
				);
				return { error: true };
			});
	};
}

let validRequest: number;
let oldAbortController: AbortController | undefined;

/** Action Creator */
export function filterShopCustomers(
	keyword: string,
	shopId?: IShopCard['id'],
	currentPage?: number,
	clean: boolean = true,
) {
	return (dispatch, getState: () => IStore) => {
		dispatch(shopCardRequest());

		if (!shopId) {
			shopId = getState().shopcard.shopcard?.id;
		}
		if (!shopId) {
			console.warn('Missing shopId');
			return;
		}
		currentPage = currentPage || getState().shopcard.customers.currentPage || 1;
		const itemsPerPage: number = getState().shopcard.customers.itemsPerPage;

		const thisRequest = Math.random();
		validRequest = thisRequest;

		if (typeof AbortController !== 'undefined') {
			if (oldAbortController && !oldAbortController.signal.aborted) {
				oldAbortController.abort();
			}
			oldAbortController = new AbortController();
		}

		const queryString =
			'?currentPage=' + currentPage + '&itemsPerPage=' + itemsPerPage + '&shopId=' + shopId + '&keyword=' + keyword;

		return fetch(getState().fetchDefault.baseAPI + 'api/Shop/SearchCustomers' + queryString, {
			...getState().fetchDefault.requestInit,
			method: 'GET',
			signal: oldAbortController ? oldAbortController.signal : undefined,
		})
			.then((res) => {
				if (validRequest !== thisRequest) {
					return;
				}
				if (res.ok) {
					return res.json().then((customers: IPage<ICustomer>) => {
						const existingCustomerItems = getState().shopcard.customers?.items;
						const customersToSet: IPage<ICustomer> = {
							...customers,
							items: clean ? [...customers.items] : [...existingCustomerItems, ...customers.items],
						};
						// Filter out walk-in customer
						if (customers?.items?.find((i) => i?.email === 'walk-in@glossiq.com')) {
							customersToSet.totalItems = customers.totalItems - 1;
						}
						const filteredCustomerItems = [...customersToSet.items].filter(
							(customer) => customer?.email !== 'walk-in@glossiq.com',
						);
						customersToSet.items = filteredCustomerItems;
						dispatch(setShopCustomersRequest(customersToSet));
					});
				} else {
					return res.json().then((res) => dispatch(shopCardFailure(res)));
				}
			})
			.catch((err) => {
				if ((oldAbortController && oldAbortController.signal.aborted) || validRequest !== thisRequest) {
					return;
				}
				dispatch(shopCardFailure(err));
			});
	};
}

/** Action Creator */
export function getShopFollowers(shopId: string, isFirstLoad: boolean, keyword: string) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetShopFollowersData());
		}

		dispatch(shopCardRequest());

		const userPreferences: IUserPreferences = getState().userPreferences;

		const currentPage: number = getState().shopcard.followersPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().shopcard.followersPage.itemsPerPage;

		const searchData: ISearchDto = {
			keyword,
			currentPage: newPage,
			itemsPerPage,
		};

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Shop/' + shopId + '/Followers',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(searchData),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IPage) => {
						if (isFirstLoad) {
							dispatch(resetShopFollowersData());
						}
						const shopCardState: IShopCardData = getState().shopcard;
						const followersItems: IFollowerDto[] = shopCardState.followersItems;
						Array.prototype.push.apply(followersItems, res.items);
						dispatch(getShopFollowersSuccess(followersItems));
						dispatch(setShopFollowersPage(res));

						if (userPreferences.id !== null) {
							dispatch(getFollowersButtonsData(res.items));
						} else {
							dispatch(updateFollowersButtonsData(null));
						}
					});
				} else {
					return res.json().then((res) => dispatch(shopCardFailure(res)));
				}
			})
			.catch((err) => {
				dispatch(shopCardFailure(err));
			});
	};
}

/** Action Creator */
export function followShop(id: string, onSuccess?: () => void) {
	return (dispatch, getState: () => IStore) => {
		dispatch(followShopStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/shop/' + id + '/follow',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
			}),
		)
			.then((res) => {
				if (res.ok || res.status === 409) {
					dispatch(followShopSuccess());
					dispatch(updateShopFollowersCount());
					if (typeof onSuccess === 'function') {
						onSuccess();
					}
					return;
				} else {
					return dispatch(followShopFailure(res));
				}
			})
			.catch((err) => {
				console.warn(err);
				dispatch(followShopFailure(err));
			});
	};
}

/** Action Creator */
export function unfollowShop(id: string, onSuccess?: () => void) {
	return (dispatch, getState: () => IStore) => {
		dispatch(shopCardRequest());
		dispatch(followShopStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/shop/' + id + '/follow',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'DELETE',
			}),
		)
			.then((res) => {
				if (res.ok || res.status === 409) {
					dispatch(unfollowShopSuccess());
					dispatch(updateShopFollowersCount(true));
					if (typeof onSuccess === 'function') {
						onSuccess();
					}
				} else {
					return res.json().then((res) => dispatch(shopCardFailure(res)));
				}
			})
			.catch((err) => {
				dispatch(shopCardFailure(err));
			});
	};
}

/** Action Creator */
export function updateFollowerInList(itemId: string, isUnfollow: boolean = false) {
	return (dispatch, getState: () => IStore) => {
		const shopCardState: IShopCardData = getState().shopcard;

		const shopFollowersItems: IFollowerDto[] = shopCardState.followersItems;
		const followerItemToUpdate = shopFollowersItems.find((x) => JSON.parse(x.entityId).id === itemId);
		const followerItemIndex = shopFollowersItems.indexOf(followerItemToUpdate);

		if (followerItemToUpdate !== undefined) {
			if (isUnfollow) {
				followerItemToUpdate.followersCount--;
				followerItemToUpdate.following = false;
			} else {
				followerItemToUpdate.followersCount++;
				followerItemToUpdate.following = true;
			}

			shopFollowersItems[followerItemIndex] = followerItemToUpdate;
			dispatch(getShopFollowersSuccess(shopFollowersItems));
		}
	};
}

/** Action Creator */
export function getFollowersButtonsData(items: IFollowCardItem[]) {
	return (dispatch, getState: () => IStore) => {
		if (!accessTokenIsPresent()) {
			return Promise.resolve(false);
		}
		dispatch(shopCardRequest());

		const itemsToGet: IEntityDto[] = items.map((item) => {
			return {
				entityId: item.entityId,
			};
		});

		return fetch(
			getState().fetchDefault.baseAPI + 'api/User/Following',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(itemsToGet),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						dispatch(updateFollowersButtonsData(res));
					});
				} else {
					return res.json().then((res) => dispatch(shopCardFailure(res)));
				}
			})
			.catch((err) => {
				dispatch(shopCardFailure(err));
			});
	};
}

/** Action Creator */
export function updateFollowersButtonsData(followingItems: IFollowingItem[]) {
	return (dispatch, getState: () => IStore) => {
		const shopCardState: IShopCardData = getState().shopcard;

		let itemsToUpdate: IFollowCardItem[] = [];
		itemsToUpdate = shopCardState.followersItems;

		if (followingItems !== null) {
			followingItems.map((followingItem: IFollowingItem) => {
				const item: IFollowCardItem = itemsToUpdate.filter((i) => i.entityId === followingItem.key.entityId)[0];
				const itemIndex = itemsToUpdate.indexOf(item);
				item.following = followingItem.value;
				itemsToUpdate[itemIndex] = item;
			});
		} else {
			itemsToUpdate.map((item) => {
				item.following = false;
			});
		}

		dispatch(getShopFollowersSuccess(itemsToUpdate));
	};
}

/** Action Creator */
export function followUser(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(shopCardRequest());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/user/' + id + '/follow',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(updateFollowerInList(id));
				} else {
					dispatch(shopCardFailure(res));
				}
			})
			.catch((err) => {
				dispatch(shopCardFailure(err));
			});
	};
}

/** Action Creator */
export function unfollowUser(id: string, onSuccess?: () => void) {
	return (dispatch, getState: () => IStore) => {
		dispatch(shopCardRequest());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/user/' + id + '/follow',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'DELETE',
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(updateFollowerInList(id, true));
					if (typeof onSuccess === 'function') {
						onSuccess();
					}
				} else {
					return dispatch(shopCardFailure(res));
				}
			})
			.catch((err) => {
				dispatch(shopCardFailure(err));
			});
	};
}

/** Action Creator */
export function getShopShippingOptions(shopId: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(shopCardRequest());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Shop/' + shopId + '/ShippingOptions',
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						dispatch(getShippingOptionsSuccess(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(shopCardFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(shopCardFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(shopCardFailure(err));
			});
	};
}

/** Action Creator */
export function updateShopFollowersCount(isUnfollow: boolean = false) {
	return (dispatch, getState: () => IStore) => {
		const state = getState().shopcard;
		const shopCard: IShopCard = state ? state.shopcard : null;
		if (shopCard) {
			if (isUnfollow) {
				shopCard.followersCount--;
			} else {
				shopCard.followersCount++;
			}
		}
		dispatch(shopCardSuccess(shopCard));
	};
}

/** Action Creator */
export function shopCardRequest(): IShopCardAction {
	return {
		type: GET_REQUEST,
	};
}

/** Action Creator */
export function shopCardSuccess(shopcard?: IShopCard): IShopCardAction {
	return {
		type: GET_SUCCESS,
		payload: {
			shopcard,
		},
	};
}

/** Action Creator */
export function shopCardFailure(message: any): IShopCardAction {
	return {
		type: GET_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function followShopStart(): IShopCardAction {
	return {
		type: FOLLOW_SHOP_REQUEST,
	};
}

/** Action Creator */
export function followShopSuccess(): IShopCardAction {
	return {
		type: FOLLOW_SHOP_SUCCESS,
	};
}

/** Action Creator */
export function followShopFailure(message: any): IShopCardAction {
	return {
		type: FOLLOW_SHOP_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function setShopCustomersRequest(customers: IPage<ICustomer>): IShopCardAction {
	return {
		type: GET_CUSTOMERS_REQUEST,
		payload: {
			customers,
		},
	};
}

/** Action Creator */
export function resetShopCustomersRequest(): IShopCardAction {
	return {
		type: RESET_CUSTOMERS_REQUEST,
	};
}

/** Action Creator */
export function setShopSingleCustomerRequest(selectedCustomer: ICustomer): IShopCardAction {
	return {
		type: GET_CUSTOMERS_CUSTOMER_REQUEST,
		payload: {
			selectedCustomer,
		},
	};
}

/** Action Creator */
export function resetShopSingleCustomerRequest(): IShopCardAction {
	return {
		type: RESET_CUSTOMERS_CUSTOMER_REQUEST,
	};
}

/** Action Creator */
export function addSingleCustomer(customers: IPage<ICustomer>): IShopCardAction {
	return {
		type: SET_CUSTOMER_REQUEST,
		payload: {
			customers,
		},
	};
}

/** Action Creator */
export function setShopIsFollowed(isFollowed: boolean): IShopCardAction {
	return {
		type: SET_IS_FOLLOWED,
		payload: {
			isFollowed,
		},
	};
}

/** Action Creator */
export function getShopFollowersSuccess(followersItems: IFollowCardItem[]): IShopCardAction {
	return {
		type: GET_SHOP_FOLLOWERS_SUCCESS,
		payload: {
			followersItems,
		},
	};
}

/** Action Creator */
export function setShopFollowersPage(followersPage: IPage): IShopCardAction {
	return {
		type: SET_SHOP_FOLLOWERS_PAGE,
		payload: {
			followersPage,
		},
	};
}

/** Action Creator */
export function setIsMyShop(isMyShop: boolean): IShopCardAction {
	return {
		type: SET_IS_MY_SHOP,
		payload: {
			isMyShop,
		},
	};
}

/** Action Creator */
export function resetShopFollowersData(): IShopCardAction {
	return {
		type: RESET_SHOP_FOLLOWERS_DATA,
	};
}

/** Action Creator */
export function resetData(): IShopCardAction {
	return {
		type: RESET_DATA,
	};
}

/** Action Creator */
export function unfollowShopSuccess(): IShopCardAction {
	return {
		type: UNFOLLOW_SHOP_SUCCESS,
	};
}

export function setKeywordFilter(keywordFilter: string): IShopCardAction {
	return {
		type: SET_KEYWORD_FILTER,
		payload: {
			keywordFilter,
		},
	};
}

/** Action Creator */
export function setNavigateToShopFollowers(navigateToFollowers: boolean): IShopCardAction {
	return {
		type: SET_NAVIGATE_TO_SHOP_FOLLOWERS,
		payload: {
			navigateToFollowers,
		},
	};
}

/** Action Creator */
export function getShippingOptionsSuccess(shippingOptions: IShopShippingOption[]): IShopCardAction {
	return {
		type: GET_SHIPPING_OPTIONS_SUCCESS,
		payload: {
			shippingOptions,
		},
	};
}

/** Action Creator */
export function setEditServicesPosition(editServicesPagePosition: {
	entireHeight: number;
	lastPosition: number;
	officeId: string;
}): IShopCardAction {
	return {
		type: SET_EDIT_SERVICES_POSITION,
		payload: {
			editServicesPagePosition,
		},
	};
}
